import { Component, OnInit, OnDestroy, inject } from '@angular/core'
import { interval, Subscription } from 'rxjs'
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog'
import { AuthService } from './auth.service'
import { CdkScrollable } from '@angular/cdk/scrolling'
import { MatButton } from '@angular/material/button'

@Component({
  selector: 'app-timeout-dialog',
  styles: [
    `
      .timeout {
        width: 30vw;
        min-width: 300px;
      }

      button {
        background: white !important;
        color: black !important;
        width: 10vw;
        min-width: 140px;
      }
    `,
  ],
  template: `
    <div class="timeout">
      <h1 mat-dialog-title>Are you still there?</h1>
      <div mat-dialog-content>
        Your current SAGE session is about to expire. For your security, SAGE sessions automatically
        end after a period of inactivity. <br /><br />
        Your current session will expire in {{ timeLeft }} seconds.
      </div>
      <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close="Reset">Continue Session</button>
        <button mat-stroked-button mat-dialog-close="Sign Out">Sign Out</button>
      </div>
    </div>
  `,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class TimeoutDialogComponent implements OnInit, OnDestroy {
  private dialogRef = inject<MatDialogRef<TimeoutDialogComponent>>(MatDialogRef)
  private authService = inject(AuthService)

  timeLeft = 60
  timerSubscription: Subscription

  ngOnInit() {
    this.timerSubscription = interval(1000).subscribe(() => {
      this.timeLeft--
      if (this.timeLeft <= 0) {
        this.authService.signOut()
        this.dialogRef.close('signout')
      }
    })
  }

  ngOnDestroy() {
    this.timerSubscription.unsubscribe()
  }
}
